import { GRAMMAR_LAST_KEY, grammarReadKey } from './path';

// Отметки одного браузера для «Грамматики». localStorage — всегда в try/catch: в приватном окне его может не быть,
// тогда «Продолжить» ведёт по данным сервера.

/** Последний открытый урок (пишет LessonPlayer) — для «Продолжить» и «ты здесь». */
export function readLastSlug(): string | null {
  try {
    return window.localStorage.getItem(GRAMMAR_LAST_KEY);
  } catch {
    return null;
  }
}

/** Урок дочитан в этом браузере — запасной путь, пока сервер не отдаёт `progress.lesson_done` (§ 8, B2). */
export function isReadHere(slug: string): boolean {
  try {
    return window.localStorage.getItem(grammarReadKey(slug)) === '1';
  } catch {
    return false;
  }
}

export function markReadHere(slug: string): void {
  try {
    window.localStorage.setItem(grammarReadKey(slug), '1');
  } catch {
    // Хранилище недоступно — отметка останется только на сервере (если он её принимает).
  }
}
